// Deprecated.
// Use the default export instead.

var PhoneInput = require('./commonjs/PhoneInputNativeDefaultMetadata').default;
exports = module.exports = PhoneInput;
exports['default'] = PhoneInput;